import { Seller } from '../../models';
import { ErrorResponse } from '~shared/models';

export interface SellerState {
  payload: Seller;
  loading: boolean;
  error: ErrorResponse;
}

export const sellerInitialState: SellerState = {
  payload: null,
  loading: false,
  error: null
};
